"use client";
'use strict';

var React = require('react');

/**
 * This React hook help you to avoid this error with a function that return a boolean, `isMounted`.
 *
 * @example
 * ```javascript
 * const isMounted = useIsMounted()
 * ```
 */
function useIsMounted() {
    const isMounted = React.useRef(false);
    React.useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return React.useCallback(() => isMounted.current, []);
}

exports.useIsMounted = useIsMounted;
//# sourceMappingURL=useIsMounted.js.map
